











































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import TermsPopup from '@/views/auth/components/TermsPopup.vue'

@Component({
  components: {
    TermsPopup,
    Icon
  }
})
export default class Auth extends Vue {
  showTermsPopup: boolean = false

  get isMobile () {
    return window.innerWidth < 768
  }

  toggleTermsPopup (value: boolean): void {
    this.showTermsPopup = value
  }

  mounted () {
    document.body.style.overflowY = 'auto'
  }
}
